import { render, staticRenderFns } from "./pact.vue?vue&type=template&id=655a03e1&scoped=true"
import script from "./pact.vue?vue&type=script&lang=js"
export * from "./pact.vue?vue&type=script&lang=js"
import style0 from "../assets/css/about.css?vue&type=style&index=0&id=655a03e1&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "655a03e1",
  null
  
)

export default component.exports